import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/modelViewer/modelViewer.sss';

export default class ModelViewer extends Component {
	constructor(props) {
		super(props);

		this.arSupportCheckCount = 0;
		this.checkCanActivateAR = this.checkCanActivateAR.bind(this);

		this.state = {
			arNotSupported: false,
			arActive: false,
			loading: true,
		};

		this.start = this.start.bind(this);
		this.stop = this.stop.bind(this);
	}

	componentDidMount() {
		if (!this.model.canActivateAR) {
			this.markArNotSupported();
		}
		this.checkCanActivateAR();

		this.model.addEventListener('load', () => {
			this.setState({ loading: false });
			this.props.onModelLoaded();
		});
		this.model.addEventListener('model-visibility', (e) => {
			this.props.onModelVisibility(e);
		});
		this.model.addEventListener('progress', (e) => {
			if (!this.state.loading) {
				this.setState({ loading: true });
			}
			const progress = e?.detail?.totalProgress;
			if (progress <= 0.0) {
				this.props.onModelLoadStarted();
			}
			this.props.onModelLoading(progress);
			if (progress === 1) {
				this.props.onModelLoadedCompleted();
			}
		});
		this.model.addEventListener('error', (e) => {
			this.setState({ arNotSupported: true, loading: false });
			this.props.onError(e);
		});
		this.model.addEventListener('ar-status', (e) => {
			if (e.detail.status === 'object-placed') {
				this.start();
			} else if (e.detail.status === 'failed') {
				this.setState({ arNotSupported: true, loading: false });
				this.props.onError(e);
			} else {
				this.stop();
			}
		});
		// this.model.addEventListener('ar-tracking', (e) => {
		// 	// console.log('ar-tracking', e);
		// 	this.props.onARTracking(e);
		// });
	}

	checkCanActivateAR() {
		this.arSupportCheckCount++;
		if (!this.model.canActivateAR) {
			this.markArNotSupported();
			return;
		}
		if (this.arSupportCheckCount < 3) {
			setTimeout(this.checkCanActivateAR, 1000);
		}
	}

	markArNotSupported() {
		this.setState({ arNotSupported: true });
		this.props.onARNotSupported();
	}

	start() {
		this.model.play();
		this.setState({ arActive: true });
		this.props.onModelStarted();
	}

	stop() {
		this.model.pause();
		this.props.onModelStopped();
	}

	render({ gltf, usdz, imageRegionRoot }, { arNotSupported, loading }) {
		return (
			<div class={s.wrapper}>
				<div class={joinClasses(s.viewerWrapper, loading && s.loading)}>
					<model-viewer
						ref={(ref) => (this.model = ref)}
						alt=""
						src={gltf}
						ios-src={usdz}
						// poster={`${imageRegionRoot}/tt.png`}
						camera-controls
						autoplay
						auto-rotate
						ar
						ar-modes="webxr scene-viewer quick-look"
						ar-placement="floor"
						reveal="interaction"
						class={joinClasses(s.modelViewer, arNotSupported && s.hide)}
					>
						<button class={s.arButton} slot="ar-button" id="model-viewer-ar-button" />
					</model-viewer>
				</div>
			</div>
		);
	}
}